const userInfoEndpoint = "/admin-panel/user-info";

const userInfo = () => {
	return axios.get(userInfoEndpoint);
}

export { userInfo };